import React, { useState, useContext } from "react";
import MyContext from "../../../MyContext";

const PricingSection = () => {
  const [billing, setBilling] = useState("monthly");
 const { openFreeTrialModal } = useContext(MyContext);

  return (
    <>


    
      <style>{`
   .pricing-wrapper {
  min-height: 100vh;
  background: linear-gradient(to bottom, #3a001a 0%, #9e104c 100%);
  padding: 80px 0;
}

/* Toggle */
.billing-toggle {
  display: inline-flex;
  background: #2a0014;
  border-radius: 30px;
  padding: 5px;
  border: 1px solid #ff2f75;
}

.toggle-btn {
  border: none;
  background: transparent;
  color: #fff;
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 14px;
}

.toggle-btn.active {
  background: #ff2f75;
}

/* Cards */
.pricing-card1 {
  background: linear-gradient(185deg, #9e104c, #280410);
  border-radius: 16px;
  padding: 30px;
  text-align: left;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  min-height: 100%;
}

/* Button */
.free-button {
  border: 1.5px solid #ff2f75;
  color: #ff2f75;
  background: transparent;
  transition: all 0.25s ease;
}

.free-button:hover {
  background: #ff2f75;
  color: #ffffff;
}

.price {
  font-size: 48px;
  font-weight: bold;
}

/* Feature table */
.feature-table {
  margin-top: 40px;
}

.feature-row {
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 14px;
}

/* Check styles */
.check-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.check-circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1.5px solid #ffffff;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-text {
  font-size: 14px;
  text-align: left;
}
      `}</style>

      <div className="pricing-wrapper">
        <div className="container text-center text-white">
          {/* Header */}
          <h1 className="fw-bold mb-2">Choose a plan that’s right for your</h1>
          <p className="text-white mb-4">
            Try our free plan risk free for 7 days. switch plans or cancel
            anytime.
          </p>

          {/* Toggle */}
          <div className="billing-toggle mb-5">
            <button
              className={`toggle-btn ${billing === "monthly" ? "active" : ""}`}
              onClick={() => setBilling("monthly")}
            >
              Monthly
            </button>
            <button
              className={`toggle-btn ${billing === "yearly" ? "active" : ""}`}
              onClick={() => setBilling("yearly")}
            >
              Yearly 40% off
            </button>
          </div>

          {/* Cards */}
          <div className="row justify-content-center g-4 mb-5 align-items-stretch">
            {/* Basic */}
            <div className="col-md-5 col-sm-12 d-flex">
              <div className="pricing-card1 w-100 d-flex flex-column">
                <h5 className="mb-2 mt-2 fs-4 fw-normal">Basic</h5>
                <p className="text-white fs-6 fw-lighter">
                  Best for personal use.
                </p>

                <div className="d-flex align-items-end gap-2">
                  <h2 className="price text-white mb-0">₹0</h2>
                  <p className="text-white mb-2">/ per month</p>
                </div>

                {/* Button at bottom */}
                <div className="mt-auto">
                  <button
                    onClick={openFreeTrialModal}
                    className="free-button w-100 mt-5 rounded-pill p-2"
                  >
                    Start Free Trial
                  </button>
                    </div>
              </div>
            </div>

            {/* Enterprise */}
            <div className="col-md-5 col-sm-12 d-flex">
              <div className="pricing-card1 w-100 d-flex flex-column">
                <h5 className="mb-2 mt-2">Enterprise</h5>
                <p className="text-white">
                  Best for growing teams & corporations.
                </p>

                <div className="d-flex align-items-end gap-2">
                  <h2 className="price text-white">
                    ₹{billing === "monthly" ? "2499" : "1799"}
                  </h2>
                  <p className="text-white">/ per month</p>
                </div>

                {/* Button at bottom */}
                <div className="mt-auto">
                  <button className="free-button w-100 mt-5 rounded-pill p-2">
                    Buy Now →
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Feature Table */}
          <div className="feature-table-wrapper position-relative">
            <div className="feature-table text-start">
              <div className="row fw-bold border-bottom pb-2 mb-3">
                <div className="col-4 text-start">Features</div>
                <div className="col-4 text-start">Free Trial</div>
                <div className="col-4 text-start">Enterprise</div>
              </div>

              {[
                ["Campaign Limit", "Up to 10 Campaigns", "Unlimited Campaigns"],
                ["Broadcast Messages", "Limited", "Unlimited"],
                [
                  "Template Creation",
                  "Up to 15 Templates",
                  "Unlimited Templates",
                ],
                ["Contact Management", "Basic", "Advanced"],
                ["WhatsApp Chat Inbox", "Shared Inbox", "Advanced Team Inbox"],
                ["User Access", "5–10 Team Members", "Unlimited Team Members"],
                ["Chatbot / Automation", "Basic", "Advanced Automation"],
                ["Analytics & Reports", "Basic Analytics", "Advanced Insights"],
                ["Customer Support", "Email Support", "Priority Support"],
              ].map((item, i) => (
                <div className="row feature-row" key={i}>
                  <div className="col-4">{item[0]}</div>

                  <div className="col-4 d-flex align-items-center">
                    <span className="check-wrap">
                      <span className="check-circle">✔</span>
                      <span className="check-text">{item[1]}</span>
                    </span>
                  </div>

                  <div className="col-4 d-flex align-items-center">
                    <span className="check-wrap">
                      <span className="check-circle">✔</span>
                      <span className="check-text">{item[2]}</span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingSection;
